import { PaymentType as AppPaymentType } from '@/features/orders/constants/app'
import { PaymentType as FirebasePaymentType } from '@/features/orders/constants/firebase'

export const firebaseToAppPaymentType: Record<FirebasePaymentType, AppPaymentType> = {
    [FirebasePaymentType.CardOnsite]: AppPaymentType.CardOnsite,
    [FirebasePaymentType.Cash]: AppPaymentType.Cash,
    [FirebasePaymentType.Invoice]: AppPaymentType.Invoice,
    [FirebasePaymentType.MealVoucher]: AppPaymentType.MealVoucher,
    [FirebasePaymentType.MealVoucherCard]: AppPaymentType.MealVoucherCard,
    [FirebasePaymentType.Online]: AppPaymentType.Online,
}
